<template>
    <router-view v-if="$route.name==='screenvgaAdd' || $route.name==='screenvgaEdit'"></router-view>
    <content-view
        class="accountList"
        v-else
    >
        <div class="bg-white pl32 pr32 pt32">
            <h4 class="orderBigList-title">{{$route.meta.name}}列表</h4>
            <div class="mt16">
                <a-button
                    type="primary"
                    class="mr8"
                    @click="addFleet"
                >新增
                </a-button>
            </div>
            <a-table
                :columns="columns"
                :dataSource="fleetList"
                :rowKey="record => record.id"
                bordered
                class="mt24"
                :pagination="pagination"
                @change="pageChange"
            >
                <template
                    slot="accountStatus"
                    slot-scope="text, record"
                >
                    {{text * 1 ?'正常':'禁用'}}
                </template>
                <template
                    slot="operation"
                    slot-scope="text, record"
                >
                    <a
                        @click="edit(text.district_code)"
                        class="btn btn_text"
                    >编辑</a>                    
                </template>
            </a-table>
            
        </div>
    </content-view>
</template>
<script>
    export default {
        name: "orderMergeList",
        data() {
            return {
                form: {},
                columns: [
                    {
                        title: "区域",
                        dataIndex: "district",
                        key: 'district'
                    },
                    {
                        title: "宽",
                        dataIndex: "siz_wide",
                        key: 'siz_wide'
                    },
                    {
                        title: "高",
                        dataIndex: "siz_long",
                        key: 'siz_long'
                    },

                    {
                        title: "操作",
                        dataIndex: "",
                        scopedSlots: {customRender: "operation"},
                        key: 'operation'
                    }
                ],
                fleetList: [],
                pagination: {
                    //默认当前页
                    defaultCurrent: 1,
                    defaultPageSize: 10,
                    showTotal() {
                        return `共 ${this.total} 条数据`;
                    },
                    showSizeChanger: true,
                    total: 0
                },
                page: 1,
                limit: 10,
            };
        },
        components: {},
        computed: {},
        methods: {
            //获得账号列表
            //page:页 limit每页条数
            getList(status = false) {
                this.form.page = this.page;
                this.form.limit = this.limit;
                this.$api.screenvga.screenList(this.form)
                    .then(res => {
                        this.pagination.total = res.total * 1;
                        this.fleetList = res.data.list;
                        status
                            ? this.$message.success("共查询到" + res.total + "条信息")
                            : "";
                    });
            },
            // 分页
            pageChange(pagination) {
                this.$set(this.pagination, "current", pagination.current);
                this.$set(this.pagination, "pageSize", pagination.pageSize);
                this.page = pagination.current;
                this.limit = pagination.pageSize;
                this.getList();
            },
            //新增按钮操作——跳转到新增页面
            addFleet() {
                this.$router.push({
                    name: "screenvgaAdd"
                });
            },
            //编辑按钮操作——跳转到编辑页面
            edit(id) {
                this.$router.push({
                    name: "screenvgaEdit",
                    query: {district_code: id}
                });
            },
        },
        mounted() {
            
        },
        created() {
            this.getList();
        },
        watch: {
            $route(val) {
                if (val.name === "screenvgaList") {
                    this.$set(this.pagination, "current", 1);
                    this.$set(this.pagination, "pageSize", 10);
                    this.page = 1;
                    this.limit = 10;
                    this.getList();
                }
            }
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss">
    .orderBigList {
        &-title {
            color: $title-color-black-85;
            @include pxAndLh(16);
            font-weight: bold;
        }
    }
</style>
